<template>
    <v-list nav dense>
        <template>
            <v-list-item
                    link
                    router to="/residents"
                    class="list"
                    active-class="green darken-1 white--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{$t('residentes')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                    link
                    router to="/workers"
                    class="list"
                    active-class="green darken-1 white--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-badge-account</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{$t('workers')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                    link
                    router to="/invitation"
                    class="list"
                    active-class="green darken-1 white--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-calendar</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{$t('Invitacion')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                v-show="getProfile.enable_parcel === true"
                    link
                    router to="/parcel"
                    class="list"
                    active-class="green darken-1 white--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-truck</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{$t('parcel')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                v-show="getProfile.water_service_enabled === true"
                    link
                    router to="/water_service"
                    class="list"
                    active-class="green darken-1 white--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-tanker-truck</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{$t('water_service')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                    link
                    router to="/historical"
                    class="list"
                    active-class="green darken-1 white--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-book-open-page-variant</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{$t('Historial')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
<!--            <v-list-item-->
<!--                    link-->
<!--                    router to="/account_statements_main_resident"-->
<!--                    class="list"-->
<!--                    active-class="green darken-1 white&#45;&#45;text"-->
<!--            >-->
<!--                <v-list-item-action>-->
<!--                    <v-icon>mdi-account-cash</v-icon>-->
<!--                </v-list-item-action>-->
<!--                <v-list-item-content>-->
<!--                    <v-list-item-title>-->
<!--                        {{$t('account_statements')}}-->
<!--                    </v-list-item-title>-->
<!--                </v-list-item-content>-->
<!--            </v-list-item>-->
            <v-list-item
                    link
                    router to="/notices"
                    class="list"
                    active-class="green darken-1 white--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-bullhorn</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title
                    >
                        {{$t('Notices')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                    v-show="getProfile.enable_reports === true"
                    link
                    router to="/reports"
                    class="list"
                    active-class="green darken-1 white--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-alert</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title
                    >
                        {{$t('Reports')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                    link
                    router to="/settings"
                    class="list"
                    active-class="green darken-1 white--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-cog-outline</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{$t('configuracion')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item
                    link
                    router to="/ayuda"
                    class="list"
                    active-class="green darken-1 white--text"
            >
                <v-list-item-action>
                    <v-icon>mdi-help-circle</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>
                        {{$t('Ayuda')}}
                    </v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </template>
    </v-list>
</template>

<script>
import { mapGetters } from 'vuex'
import { AUTH_LOGOUT } from '../../store/actions/auth'

export default {
  name: 'main_resident',
  computed: {
    ...mapGetters(['getProfile'])
  },
  created () {
    if (this.getProfile.defaulter === true) {
      this.$store.commit('dialog_show_active_true')
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/'))
    }
  },
  methods: {
    clear: function () {
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    }
  }
}
</script>

<style scoped>
    .list:hover {
        background: white;
        opacity: 0.85;
    }
</style>
